import { createApp } from 'vue'
import "bootstrap/dist/css/bootstrap.min.css"
import "bootstrap"
window.$ = window.jQuery = require('jquery');
import App from './App.vue'
import router from './router'
import DefaultLayout from './layouts/DefaultLayout.vue'
import { store } from './store'
import VueSweetalert2 from 'vue-sweetalert2';
import 'sweetalert2/dist/sweetalert2.min.css';
import i18n from './plugins/i18n';
import { LoadingPlugin } from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/css/index.css';

const app = createApp(App);

app.use(store);
app.use(router);
app.use(i18n);
app.use(LoadingPlugin);
app.use(VueSweetalert2);
app.component('default-layout', DefaultLayout);
app.mount('#app')